import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  resetForm: false,
  invites: {
    loading: false,
    error: null,
    data: [],
    totalPages: 0,
    totalRecords: 0,
    page: 0,
    pageSize: 0,
    sortOn: '',
    sortDir: '',
  },
};

export const inviteSlice = createSlice({
  name: 'invites',
  initialState,
  reducers: {
    sendInviteRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    sendInviteSuccess: (state, {payload}) => {
      state.loading = false;
      state.resetForm = payload;
    },
    sendInviteError: (state, {payload}) => {
      state.loading = false;
      state.error = payload;
    },
    fetchInvitesRequest: (state) => {
      state.invites.loading = true;
      state.invites.error = null;
    },
    fetchInvitesSuccess: (state, {payload}) => {
      const {data, page, pageSize, totalPages, totalRecords, sortOn, sortDir} =
        payload;
      state.invites.loading = false;
      state.invites.data = data;
      state.invites.page = page;
      state.invites.pageSize = pageSize;
      state.invites.totalPages = totalPages;
      state.invites.totalCount = totalRecords;
      state.invites.sortOn = sortOn;
      state.invites.sortDir = sortDir;
    },
    fetchInvitesError: (state, {payload}) => {
      state.invites.loading = false;
      state.invites.error = payload;
    },
  },
});

export const {
  sendInviteRequest,
  sendInviteSuccess,
  sendInviteError,
  fetchInvitesRequest,
  fetchInvitesSuccess,
  fetchInvitesError,
} = inviteSlice.actions;

export default inviteSlice.reducer;
